


































import Vue from "vue";
import VueTelInput from "vue-tel-input";
import Field from "@/components/basic/fields/Field.vue";
import { Locale } from "@/constants/locale";
import { PhoneInterface } from "@/types";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { mapState } from "vuex";
import Error from "@/components/basic/Error.vue";

Vue.use(VueTelInput);

export default Vue.extend({
  name: "PhoneField",
  props: {
    name: String,
    value: Object,
    disabled: {
      type: [String, Boolean],
      default: false,
    },
    handlesError: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
    isValidated: {
      type: Boolean,
      default: true,
    },
    handlesDataPreload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      bindProps: {
        mode: "international",
        defaultCountry:
          this.$store.state.analyticsService.analyticsData.residency ? this.$store.state.analyticsService.analyticsData.residency : "",
        inputOptions: {
          showDialCode: true,
        },
      },
      formData: {
        phonePrefix: this.value.phonePrefix,
        phone: this.value.phone,
      } as PhoneInterface,
      TRANSLATION_KEY: "compositeFields.PhoneField",
      prefixHasError: false,
      listOfCountriesNew: [] as string[],
      preferredCountries: [] as string[],
      isInputFocused: false,
    };
  },
  mounted() {
    this.removePrefix();
    setTimeout(()=>{
      this.listOfCountriesNew = this.phonePrefixesList;
      if(UtilityHelper.getLocale() == "ru"){
        this.preferredCountries = ["UA", "PL", "RU", "LV", "LT", "BY"];
        this.listOfCountriesNew = this.listOfCountriesNew.filter( ( el ) => !this.preferredCountries.includes( el ) );
        this.listOfCountriesNew.sort();
        this.listOfCountriesNew = [...this.preferredCountries, ...this.listOfCountriesNew]
      }
    },2000);
    document.addEventListener("click", (evt: MouseEvent) => this.blurFocusOnDateField(evt));
  },
  methods: {
    validate() {
      if (this.isValidated) {
        this.removePrefix();

        this.$store.dispatch("validate", {
          name: this.name,
          value: this.formData.phone,
        });
      }
      this.$emit("blur", this.formData);
    },

    countryChanged(phonePrefix: string) {
      this.formData.phonePrefix = "+" + phonePrefix;
      this.emitValue();
    },

    emitValue() {
      this.removePrefix();
      this.$emit("input", this.formData);
      this.$emit("valueChanged", this.formData);
    },
    removePrefix() {
      if (this.formData.phone.startsWith(this.formData.phonePrefix)) {
        this.formData.phone = this.formData.phone.substr(this.formData.phonePrefix.length);
      }
    },
    isLabelShown(): boolean {
      return Boolean( this.formData.phone.length || this.isInputFocused);
    },
    setFocusOnPhoneField(): void {
      if (!this.isInputFocused) {
        this.isInputFocused = true;
      }
    },
    blurFocusOnDateField(evt: MouseEvent): void {
      if (!(evt.target as HTMLElement).closest(".field--phone") && this.isInputFocused) {
        this.isInputFocused = false;
      }
    },
  },
  computed: {
    ...mapState({
      phonePrefixesList: (state: any): [] => state.config.phonePrefixesList,
      isErrorsChanged: (state: any): boolean => state.isErrorsChanged,
    }),
  },
  watch: {
    isErrorsChanged() {
      this.prefixHasError = this.$store.state.errors.has(this.name + "Prefix");
    },
  },
  components: {
    Field,
    Error,
  },
});
